// extracted by mini-css-extract-plugin
export var gif = "_js-0";